import { createApiService } from "../../../core/api/apiService";
import type {
  CreateProfileDto,
  ProfileDto,
  UpdateProfileDto,
} from "../types/profileTypes";

export const createProfileApiClient = () => {
  const client = createApiService("profiles");

  return {
    /**
     * Get current user's profile
     */
    async getMe(): Promise<ProfileDto> {
      return client.get<ProfileDto>("/me");
    },

    /**
     * Create profile for current user
     */
    async create(data: CreateProfileDto): Promise<ProfileDto> {
      return client.post<ProfileDto>("", data);
    },

    /**
     * Update current user's profile
     */
    async update(data: UpdateProfileDto): Promise<ProfileDto> {
      return client.put<ProfileDto>("", data);
    },

    /**
     * Delete current user's profile
     */
    async delete(): Promise<{ message: string }> {
      return client.delete<{ message: string }>("");
    },
  };
};

const profileApiService = createProfileApiClient();
export { profileApiService };
